import { Options as SplideOptions } from '@splidejs/splide'
import React, { ComponentProps } from 'react'
import styled from 'styled-components'

import { BounceExtension, bounceExtensionCSS } from './extensions/BounceExtension'
import { Slider } from './Slider'

const StyledSlider = styled(Slider)`
  position: relative;
  .splide__arrow {
    top: 30%;

    &.splide__arrow--prev {
      left: 0;
    }

    &.splide__arrow--next {
      right: 0;
    }
  }

  .splide__pagination {
    position: relative;
    display:flex;
    justify-content: center;
    margin-top: 15px;
    .splide__pagination__page {
      background: #eee;
      border-radius: 0;
      width: 12px;
      height: 12px;
      margin: 5px;
      padding: 4px;
      opacity: 1;

      &.is-active {
        background: #146C92;
        transform: none;
      }
    }
  }

  ${bounceExtensionCSS}
`

const defaultOptions: SplideOptions = {
  autoHeight: true,
  breakpoints: {
    640: {
      perPage: 2,
    },
    900: {
      perPage: 4,
    },
  },
  gap: '.3rem',
  pagination: true,
  perPage: 5,
  slider: false,
  type: 'slider',
  width: '100%',
}

export const ContainerSlider: React.FC<ComponentProps<typeof Slider> & ComponentProps<typeof StyledSlider>> = React.memo(({ children, options, ...rest }) => (
  <StyledSlider extensions={{ BounceExtension }} options={{ ...defaultOptions, ...options }} {...rest}>
    {children}
  </StyledSlider>
))
